var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 177,
    viewBox: "0 0 178 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.125 62.9698C75.1922 62.9698 63.8844 74.2775 63.8844 88.2104C63.8844 102.143 75.1922 113.451 89.125 113.451C103.058 113.451 114.366 102.143 114.366 88.2104C114.366 74.2775 103.058 62.9698 89.125 62.9698ZM101.493 97.0193L97.9592 100.553C97.4544 101.058 96.6719 101.058 96.1671 100.553L87.5601 91.946C84.4807 93.0313 80.8965 92.3751 78.423 89.9015C75.6212 87.0998 75.1417 82.8593 76.9338 79.5528L82.8653 85.4844L86.4242 81.9254L80.4927 76.0191C83.8244 74.2271 88.0396 74.7066 90.8413 77.5083C93.3149 79.9819 93.9712 83.5661 92.8858 86.6454L101.493 95.2525C101.972 95.7321 101.972 96.5398 101.493 97.0193Z",
    fill: "#2898A4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.125,
    cy: 88.2104,
    r: 44.0601,
    stroke: "#D6F2F5",
    strokeWidth: 1.56676
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.125,
    cy: 88.2104,
    r: 65.9198,
    stroke: "#D6F2F5",
    strokeWidth: 1.56676
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.125,
    cy: 88.2104,
    r: 87.4022,
    stroke: "#D6F2F5",
    strokeWidth: 1.61645
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/Maintenance.54932ee4366c61ea91be27fa4c48bf72.svg";
export { ForwardRef as ReactComponent };